export default __webpack_public_path__ + "fca263e67fe9eed3bfd43d568a7e0d4b.png";